// extracted by mini-css-extract-plugin
export default {"image":"background__image__fTtOi","color":"background__color__T3Wqz","video":"background__video__ycO26","videoEnabled":"background__videoEnabled__gXx7b"};